<template>
  <div class="col-12 pr-0">
    <div class="mt-4">
      <section-title
        class="mt-3"
        content="Datos del Documento"
        :has-line="true"
      />
      <div class="result-table">
        <custom-callout
          class-main="mt-3 rounded"
          :has-border="false"
          :has-toggle="false"
        >
          <div class="row py-2 mr-md-0 align-items-center">
            <div class="col-3 mt-3 mt-md-0">
              <div class="color-gray-6 font-14">
                <em class="fas fa-file-alt color-orange" />
                Documento creado por:
              </div>
            </div>
            <div class="col-2 mt-3 mt-md-0">
              <div class="color-gray-6 font-14">
                <em class="fas fa-user-circle color-orange" />
                Puesto:
              </div>
            </div>
            <div class="col-5 mt-3 mt-md-0">
              <div class="color-gray-6 font-14">
                <em class="fas fa-file-signature color-orange" />
                Propósito del Documento:
              </div>
            </div>
            <div class="color-gray-6 font-14">
              <div class="color-gray-6 font-14">
                <em class="fas fa-calendar color-orange" />
                Creado el:
              </div>
            </div>
          </div>
          <div class="row py-2 mr-md-0 align-items-center">
            <div class="col-3 mt-3 mt-md-0">
              <div class="color-black font-16 bold">
                {{ documentInformation.createdByName }}
              </div>
            </div>
            <div class="col-2 mt-3 mt-md-0">
              <div class="color-black font-16 bold">
                {{ documentInformation.createdByRole }}
              </div>
            </div>
            <div class="col-5 mt-3 mt-md-0">
              <div class="color-black font-16 bold">
                {{ documentInformation.documentPurpose }}
              </div>
            </div>
            <div class="col-2 mt-3 mt-md-0">
              <div class="color-black font-16 bold">
                {{ documentInformation.createdDate | date('DD/MMM/YYYY') }}
              </div>
            </div>
          </div>
        </custom-callout>
      </div>
    </div>
    <div class="mt-4">
      <section-title class="mt-3" content="Participantes" :has-line="true" />
      <div
        v-for="(participant, index) of participants"
        :key="`signaturesprovider-item-${index}`"
        class="result-table"
      >
        <custom-callout
          class-main="mt-3 rounded"
          :has-border="false"
          :has-toggle="false"
        >
          <div class="row py-2 mr-md-0">
            <div class="col-10 mt-3 mt-md-0" style="display: inline-flex;">
              <div
                class="row p-2"
                style="background-color: white; border-radius: 50px;"
              >
                <div
                  :class="
                    `bg-${statusColor(
                      participant.participantSignatureStatusId
                    )}`
                  "
                  style="height: 10px !important;
                width: 10px !important;
                border-radius: 20px;
                margin-top: 14px;"
                />
                <span
                  class="font-16 color-black"
                  style="padding-left: 10px; margin-top: 7px;"
                >
                  {{ participant.participantSignatureStatus | empty }}
                </span>
              </div>
            </div>
            <div class="col-2 mt-3 mt-md-0 d-flex justify-content-end">
              <action-button
                v-if="canResend(participant.participantSignatureStatusId)"
                id="btnResend"
                class="mr-1"
                i="fas fa-arrow-circle-right fa-fw"
                text="Reenviar"
                variant="outline-success"
                @click="() => onResendHandler(participant)"
              />
            </div>
          </div>

          <div class="row py-2 mr-md-0 align-items-center border-top">
            <div class="col-3 col-sm col-12 mt-3 mt-md-0">
              <div class="color-gray-6 font-14">
                {{ relationTypeTitle(participant) }}
              </div>
              <div class="color-black font-16 bold">
                {{ participant.participantPosition }}
              </div>
            </div>
            <div class="col-3 col-sm col-12 mt-3 mt-md-0">
              <div class="color-gray-6 font-14">Nombre:</div>
              <div class="color-black font-16 bold">
                {{ participant.participantName }}
              </div>
            </div>
            <div class="col-2 col-sm col-12 mt-3 mt-md-0">
              <div class="color-gray-6 font-14">
                Tipo de Firma:
              </div>
              <div class="color-black font-16 bold">
                {{ signatureType }}
              </div>
            </div>
            <div class="col-3 mt-3 mt-md-0">
              <div class="color-gray-6 font-14">Correo Electrónico:</div>
              <div class="color-black font-16 bold">
                {{ emailAndUserName(participant) }}
              </div>
            </div>
            <div class="col-2 col-sm col-12 mt-3 mt-md-0">
              <div class="color-gray-6 font-14">Fecha de Firma:</div>
              <div class="color-black font-16 bold">
                {{ participant.participantSignatureStatusDate | date }}
              </div>
            </div>
          </div>
        </custom-callout>
      </div>
    </div>
  </div>
</template>

<script>
//components
import SectionTitle from 'SectionTitle';
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';

//services
import {
  getDocumentInfo as _getDocumentInfo,
  resendInvitationSigning as _resendInvitationSigning,
} from '@/services/uspqrp/signatures-contractor.api';
import { getUserInformation as _getUserInformation } from '@/services/uspqrp/contract.api.js';

//constants
import { signatureTypeLabels } from '@/utils/constants/signatureTypes';
import ParticipantSignatureStatus, {
  ParticipantSignatureStatusColor,
} from '@/utils/constants/ParticipantSignatureStatus.js';

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin';

export default {
  name: 'SignatureElectronicInformation',
  mixins: [alertMixin],
  components: {
    SectionTitle,
    CustomCallout,
    ActionButton,
  },
  async mounted() {
    await this.getDocumentInformation();
  },
  data: () => ({
    documentInformation: [],
    participants: [],
  }),
  computed: {
    signatureType() {
      return signatureTypeLabels.Electronic;
    },
  },
  props: {
    isElectronicSignature: {
      type: Boolean,
      default: null,
      required: false,
    },
    digitalSignatureDocumentId: {
      type: String,
      default: null,
      required: false,
    },
    signatureParticipants: {
      type: Array,
      default: () => [],
      required: false,
    },
  },
  methods: {
    statusColor(statusId) {
      const hashMap = {
        [ParticipantSignatureStatus.Signed]:
          ParticipantSignatureStatusColor[ParticipantSignatureStatus.Signed],

        [ParticipantSignatureStatus.PendingSignature]:
          ParticipantSignatureStatusColor[
            ParticipantSignatureStatus.PendingSignature
          ],
      };
      return hashMap[statusId ?? ParticipantSignatureStatus.Unset];
    },
    relationTypeTitle(participant) {
      return 'ESPECIALISTA' === participant.participantPosition?.toUpperCase()
        ? 'Rol:'
        : 'Parentesco:';
    },
    emailAndUserName(participant) {
      return `${participant.participantEmail}${
        this.isElectronicSignature ? ' / ' + participant.userName : ''
      }`;
    },
    async getDocumentInformation() {
      if (this.digitalSignatureDocumentId) {
        const { data: documentInformation } = await _getDocumentInfo(
          this.digitalSignatureDocumentId
        );
        this.documentInformation = documentInformation;
        this.participants = documentInformation.statusInformation.participants;
        const participantsWithUserNames = await Promise.all(
          this.participants.map(async (item) => {
            const rs = await _getUserInformation(item.userId);
            const p = this.signatureParticipants.find(
              (x) =>
                x.email === item.participantEmail || x.userId === item.userId
            );
            return {
              ...item,
              userName: rs.data.userName,
              participantPosition:
                item.participantPosition ??
                p?.relationTypeDescription ??
                'Especialista',
            };
          })
        );
        this.participants = participantsWithUserNames;
      }
    },
    async onResendHandler(participant) {
      const payload = {
        email: participant.participantEmail,
        documentId: this.digitalSignatureDocumentId,
        userId: participant.userId,
      };
      await _resendInvitationSigning(payload)
        .then(async (res) => {
          if (res.data) {
            this.ShowToast(
              'Alerta',
              'Se ha reenviado el mensaje satisfactoriamente.',
              'success'
            );
          } else {
            this.ShowToast(
              'Alerta',
              'Ocurrió un error, intente nuevamente.',
              'error'
            );
          }
        })
        .catch(() =>
          this.ShowToast('Alerta', 'Ha ocurrido un error.', 'error')
        );
    },
    canResend(statusId) {
      return statusId === ParticipantSignatureStatus.PendingSignature;
    },
  },
};
</script>
